import { Button, Grid, IconButton, InputAdornment, TextField, Backdrop, CircularProgress, Typography } from "@mui/material"
import { useAuthService } from "../../../../use-cases/auth"
import { useEffect, useState } from "react"
import { useNavigationService } from "../../../../use-cases/navigation"
import { VisibilityOff, Visibility } from "@mui/icons-material"

export const LoginPage = () => {
  // Use State
  const [loginCliente, setLoginCliente] = useState("")
  const [loginUsuario, setLoginUsuario] = useState("")
  const [senhaUsuario, setSenhaUsuario] = useState("")
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  // Service
  const { login, logout } = useAuthService()
  const { navigateTo } = useNavigationService()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const msg = params.get('message') || params.get('reason');
    const isLogout = params.get('logout') === 'true';

    if (msg) {
      logout(msg, 'error', true);
      return;
    }

    if (isLogout) {
      logout('Sessão encerrada.', 'info', true);
      return;
    }

    const CACHE_CLEARED_KEY = 'veles_cache_cleared_session';
    const cacheCleared = sessionStorage.getItem(CACHE_CLEARED_KEY);

    if (!cacheCleared) {
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.setItem(CACHE_CLEARED_KEY, 'true');
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      });
      window.location.reload();
    }
  }, [logout]);

  const isFormValid =
    loginUsuario.trim() !== '' &&
    senhaUsuario.trim() !== '' &&
    loginCliente.trim() !== ''

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!isFormValid || isLoading) {
      return
    }
    setIsLoading(true)
    try {
      await login({
        loginCliente,
        loginUsuario,
        senhaUsuario
      })
    } catch (error) {
      setIsLoading(false)
    }
  }

  return <>
    <Backdrop
      sx={{ 
        color: '#fff', 
        zIndex: (theme) => theme.zIndex.drawer + 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
      open={isLoading}
    >
      <CircularProgress color="inherit" size={60} thickness={4} />
      <Typography variant="h6" fontWeight={600} color="inherit" textAlign="center">
        Autenticando... Por favor, aguarde.
      </Typography>
    </Backdrop>

    <form onSubmit={handleSubmit}>
      <Grid container justifyContent={"center"} spacing={3}>
        <Grid item xs={12} lg={8}>
          <TextField
            value={loginUsuario}
            disabled={isLoading}
            onChange={(e) => {
              setLoginUsuario(e.target.value)
            }}
            autoComplete="given-loginUsuario"
            name="loginUsuario"
            fullWidth
            id="loginUsuario"
            label="Usuário"
            autoFocus
          />
        </Grid>

        <Grid item xs={12} lg={8}>
          <TextField
            value={senhaUsuario}
            disabled={isLoading}
            onChange={(e) => {
              setSenhaUsuario(e.target.value)
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    disabled={isLoading}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
            name="senhaUsuario"
            fullWidth
            id="senhaUsuario"
            label="Senha"
            type={showPassword ? 'text' : 'password'}
          />
        </Grid>
        <Grid item xs={12} lg={8}>
          <TextField
            value={loginCliente}
            disabled={isLoading}
            onChange={(e) => {
              setLoginCliente(e.target.value)
            }}
            name="loginCliente"
            fullWidth
            id="loginCliente"
            label="Cliente"
          />
        </Grid>
        <Grid item xs={12} lg={8}>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={!isFormValid || isLoading}
          >
            {isLoading ? "Aguarde..." : "Acessar"}
          </Button>
        </Grid>

      </Grid>
    </form>
  </>
}
